<template>
    <CardPage :section="section" :page="page">
        <p v-for="(category, index) in myGoalsCategories" :key="index">
            {{ blurbs[category] }}
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    props: {
        section: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        blurbs: {
            type: Object,
            required: true
        }
    },
    computed: {
        myGoalsCategories: get('section4/myGoalsCategories')
    }
};
</script>
